import { Component } from '@angular/core';
import { AnyoTableComponent } from 'projects/app-core/src/app/models/AnyoTableComponent';
import { PartnerCampaignGridResponseData } from '../../../models/campaign/anyoPartnerCampaignGridResponse';
import {
  PartnerCampaignFilter,
  PartnerCampaignGridRequest,
  PartnerCampaignSort,
} from '../../../models/campaign/anyoPartnerCampaignGridRequest';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { CampaignService } from '../../../services/campaign.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { AnyoSortDirection } from 'projects/app-core/src/models/gridRequest';
import * as moment from 'moment';

interface CheckBoxOptions {
  label: string;
  value: string;
  checked: boolean;
}

@Component({
  selector: 'app-manage-campaign',
  templateUrl: './manage-campaign.component.html',
  styleUrl: './manage-campaign.component.scss',
})
export class ManageCampaignComponent extends AnyoTableComponent<
  PartnerCampaignGridResponseData,
  PartnerCampaignGridRequest
> {
  globalSearchInput = '';
  partnersCheckBoxOptions: CheckBoxOptions[] = [];
  presentersCheckBoxOptions: CheckBoxOptions[] = [];
  campaignColumnFilterDate: Date[] | undefined;
  dateFormat = 'dd-MM-yyyy';
  hideTestCampaign = false;

  constructor(
    protected override auth: AuthService,
    protected override toastService: ToastService,
    public utils: UtilsService,
    private campaign: CampaignService,
  ) {
    super(auth, toastService);
    this.gridRequest.filters = {
      [PartnerCampaignFilter.TEST_CAMPAIGN]: ['false'],
    };
    this.gridRequest.sort = {
      [PartnerCampaignSort.CAMPAIGN_DATE]: AnyoSortDirection.DESC,
    };
  }

  override async getData(): Promise<void> {
    this.pageLoading = true;
    this.campaign.getCampaignsGrid(this.gridRequest).subscribe({
      next: (value) => {
        this.data = value.data;
        this.partnersCheckBoxOptions = value.filterOptions.partners.map(
          (data) => {
            if (this.gridRequest.filters?.PARTNER_ID?.includes(data.id)) {
              return {
                label: data.name,
                value: data.id,
                checked: true,
              };
            } else {
              return {
                label: data.name,
                value: data.id,
                checked: false,
              };
            }
          },
        );
        this.presentersCheckBoxOptions = value.filterOptions.presenters.map(
          (data) => {
            return {
              label: data.presenterName,
              value: data.presenterId,
              checked:
                this.gridRequest.filters?.PRESENTER_ID?.includes(
                  data.presenterId,
                ) || false,
            };
          },
        );
        this.totalCount = value.totalRecords;
        this.pageLoading = false;
      },
      error: (err) => {
        this.pageLoading = false;
        const errorBody = err.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  searchGlobal() {
    this.gridRequest.globalSearch = [this.globalSearchInput];
    this.getData();
  }

  partnerFilter($event: string[]) {
    if (!this.gridRequest!.filters) {
      this.gridRequest!.filters = {
        [PartnerCampaignFilter.PARTNER_ID]: [],
      };
    }
    this.gridRequest!.filters!.PARTNER_ID = $event ?? [];
  }

  presenterFilter($event: string[]) {
    if (!this.gridRequest!.filters) {
      this.gridRequest!.filters = {
        [PartnerCampaignFilter.PRESENTER_ID]: [],
      };
    }
    this.gridRequest!.filters!.PRESENTER_ID = $event ?? [];
  }

  async testCampaignFilter($event: boolean): Promise<void> {
    this.hideTestCampaign = $event;
    this.gridRequest!.filters = {
      ...this.gridRequest!.filters,
      [PartnerCampaignFilter.TEST_CAMPAIGN]: $event ? ['true'] : ['false'],
    };
    await this.getData();
  }

  override async resetFilter(): Promise<void> {
    this.hideTestCampaign = false;
    this.gridRequest = {
      page: 1,
      pageSize: 10,
      export: false,
      filters: {
        [PartnerCampaignFilter.TEST_CAMPAIGN]: ['false'],
      },
      sort: {
        [PartnerCampaignSort.CAMPAIGN_DATE]: AnyoSortDirection.DESC,
      },
    };
    this.globalSearchInput = '';
    this.campaignColumnFilterDate = [];
    this.getData();
  }

  campaignDateSort(direction: string | null): void {
    if (!this.gridRequest.sort) {
      this.gridRequest.sort = {};
    }
    if (!direction) {
      delete this.gridRequest.sort[PartnerCampaignSort.CAMPAIGN_DATE];
    } else {
      this.gridRequest.sort[PartnerCampaignSort.CAMPAIGN_DATE] =
        direction === 'ascend' ? AnyoSortDirection.ASC : AnyoSortDirection.DESC;
    }
    this.getData();
  }

  formatDate(date: string) {
    return moment(date, 'x').format('DD/MM/YYYY HH:mm');
  }

  onEventsFilterDateChange($event: Date[]) {
    this.campaignColumnFilterDate = $event;
    this.gridRequest.dateFilters = {
      CAMPAIGN_ON: {
        from: moment($event[0], 'x').startOf('day').toDate(),
        to: moment($event[1], 'x').endOf('day').toDate(),
      },
    };
  }
}
